import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { translate, showMessageToastCustom, isNullOrEmpty } from '../../../../utils/util';
import { onValueChange, validateInputsRequired } from '../../../../utils/handleChangeHooks';
import { Input, Button, Title, Select, BackButton, ConfirmModal } from '../../../../components/UI/ComponentsUI';
import ChangeLocationService from '../../../../services/ChangeLocationService';
import M from 'materialize-css/dist/js/materialize';
import ConfirmationModal from './ConfirmationModal';
import useStateWithPromise from '../../../../utils/useEffectUpdate';

const MassiveUpdate = (props) => {
    const [data, setData] = useState([])
    const [locationConversion, setLocationConversion] = useStateWithPromise({
        field: 'containsLocation',
        updateFrom: '',
        updateTo: '',
        entrance: null,
        containsLocation: null,
        success: false,
        updated: false
    });
    const [confirmationModalOpen, setConfirmationModalOpen] = useState(false)

    useEffect(() => {
        if (data.length > 0) {
            setConfirmationModalOpen(true)
        }
        // eslint-disable-next-line
    }, [data]);


    const onChange = (event) => {
        onValueChange(event, locationConversion, setLocationConversion);
    };

    const submit = () => {
        if (validateInputsRequired("massiveId")) {
            var dto = {
                success: locationConversion.success,
                updated: locationConversion.updated,
                pageIndex: 0
            }

            if (locationConversion.field === 'containsLocation') {
                dto = { ...dto, containsLocation: locationConversion.updateFrom }
            } else {
                dto = { ...dto, entrance: locationConversion.updateFrom }
            }

            props.getTransmissions(dto, (c) => {
                if (c.items?.length > 0) {
                    setData(c.items);
                } else showMessageToastCustom(translate('warning', 'general'), translate('message.noRecordFound', 'delivery'), 8000, 'mdi mdi-alert-circle-outline red-text');
            });
        }
    };

    const onConfirm = () => {
        var dto = {
            success: locationConversion.success,
            updated: locationConversion.updated,
            pageIndex: 0,
            Ids: data.map(x => x.id),
        }

        if (locationConversion.field === 'containsLocation') {
            dto = { ...dto, containsLocation: locationConversion.updateFrom, updateTo: locationConversion.updateTo }
        } else {
            dto = { ...dto, entrance: locationConversion.updateFrom, updateTo: locationConversion.updateTo }
        }

        props.updateMassive(dto, () => {
            setConfirmationModalOpen(false)
            openModalReprocessConfirmation()
        });
    };

    const reprocessConfirm = () => {
        const selectedIds = data.map(x => x.id);
        props.reprocessSelected(selectedIds, () => {
            showMessageToastCustom(translate('general.info'), translate('update-success', 'change-location'), 2000, 'mdi mdi-checkbox-marked-circle-outline green-text');
            props.history.goBack()
        });
    }

    const cancelReprocess = () => {
        props.history.goBack()
    }

    const openModalReprocessConfirmation = () => {
        const modalReceived = M.Modal.init(document.getElementById('reprocessConfirmationModalOpen'));
        modalReceived.open();
    }

    const addLeadingZeros = (evt) => {
        if (!isNullOrEmpty(evt.currentTarget.value) && locationConversion?.field === "entrance") {
            evt.currentTarget.value = ("0000000000" + evt.currentTarget.value).slice(-10)
        }
        onChange(evt);
    }

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <div className="row">
                    <Title icon="mdi mdi-clipboard-check-outline" label="Conversão de Locação" />
                </div>
            </div>
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className="container">
                    <div className="card">
                        <div className="card-content" style={{ padding: '10px', paddingBlockEnd: '1px' }}>
                            <form id="massiveId">
                                <div className="row" style={{ marginBottom: '0px' }}>
                                    <div className="input-field no-padding col s12">
                                        <Select
                                            notOption="true"
                                            required
                                            id="field"
                                            name="field"
                                            placeHolder={translate('choose-one-option', 'general')}
                                            label="Campo a alterar"
                                            data={[{ id: 'containsLocation', text: "Locação" }, { id: 'entrance', text: "CIM" }]}
                                            change={(evt) => {
                                                onChange(evt);
                                                locationConversion.updateFrom = '';
                                                locationConversion.updateTo = '';
                                                setLocationConversion(locationConversion).then(() => {
                                                    M.updateTextFields();
                                                });
                                            }}
                                            defaultValue={locationConversion?.field}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s12">
                                        <Input
                                            required
                                            label={translate("from", 'physical-confirmation')}
                                            id="updateFrom"
                                            name="updateFrom"
                                            type="text"
                                            onChange={addLeadingZeros}
                                            value={locationConversion.updateFrom}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s12">
                                        <Input
                                            required
                                            label={translate("to", 'physical-confirmation')}
                                            id="updateTo"
                                            name="updateTo"
                                            type="text"
                                            onChange={addLeadingZeros}
                                            value={locationConversion.updateTo}
                                        />
                                    </div>
                                </div>
                            </form>
                            <div className="row">
                                <Button onClick={() => props.history.goBack()} text={translate('cancel', 'general')} secundary="true" />
                                <Button onClick={() => submit()} text={translate('confirm', 'general')} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ConfirmationModal
                open={confirmationModalOpen}
                id="ConfirmationModal"
                items={data}
                onCancel={() => setConfirmationModalOpen(false)}
                onConfirm={() => onConfirm()}
                locationConversion={locationConversion}
            />
            <ConfirmModal
                id="reprocessConfirmationModalOpen"
                data={{
                    title: translate('update-success', 'change-location'),
                    message: translate('confirm-reprocess', 'change-location')
                }}
                onConfirm={() => reprocessConfirm()}
                onCancel={() => cancelReprocess()}
                btnCancel={translate('cancel', 'general')}
                btnConfirm={translate('confirm', 'general')}
            />
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        usersFromElog: state.usersElogReducer.usersElog
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateMassive: (dto, callback) => {
            dispatch(ChangeLocationService.updateMassive(dto, callback));
        },
        getTransmissions: (filter, callback) => {
            dispatch(ChangeLocationService.getTransmissionsReprocess(filter, callback));
        },
        reprocessSelected: (selectedIds, callback) => {
            dispatch(ChangeLocationService.reprocessSelected(selectedIds, callback));
        },
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(MassiveUpdate)));
